import {
  css,
  P,
  rem,
  styled,
  theme,
  TicketIcon,
  TicketSlashIcon,
} from 'design-system';

import { SectionInner } from '../components/section';
import { Voucher } from '../vouchers/get-voucher';

export const VoucherBannerHome = ({ voucher }: { voucher: Voucher }) => {
  if (voucher.voucherStatus === 'NONE' || voucher.voucherStatus === 'UNKNOWN') {
    return null;
  }

  return (
    <VoucherContainer
      aria-label="Voucher Banner"
      css={{
        borderRadius: '10px',
        color: theme.colors.yellowAlpha8,

        border: `1px dashed ${theme.colors.yellowAlpha8}`,
        backgroundColor: 'rgba(255, 247, 209, 0.50)',
        padding: '7px 15px',
      }}
    >
      <SectionInner
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <P
          size="medium"
          css={{
            color:
              voucher.voucherStatus === 'VALID'
                ? theme.colors.yellowAlpha8
                : theme.colors.yellow11,
            fontWeight: theme.fontWeights.medium,
            display: 'flex',
            gap: rem(12),
            alignItems: 'center',
          }}
          data-test-id="voucher-message"
        >
          {voucher.voucherStatus === 'VALID' ? (
            <TicketIcon width={rem(24)} />
          ) : (
            <TicketSlashIcon className={ticketSlashStyles()} />
          )}
          {voucher.message}
        </P>
      </SectionInner>
    </VoucherContainer>
  );
};

const ticketSlashStyles = css({
  width: rem(24),
  height: rem(18),
});

const VoucherContainer = styled('div', {
  borderRadius: '10px',
  color: theme.colors.yellowAlpha8,

  border: `1px dashed ${theme.colors.yellowAlpha8}`,
  backgroundColor: 'rgba(255, 247, 209, 0.50)',
  padding: '7px 15px',
});
